import { useContext } from "react";
import {
  Card,
  Layout,
  Text,
  VerticalStack,
  HorizontalStack,
  Button,
} from "@shopify/polaris";
import { useAppBridge } from "@shopify/app-bridge-react";
import { captureException } from "@sentry/react";
import AppContext from "./AppContext";
import { authenticateAndLogin } from "../utils/navUtils";
import {
  emitAmplitudeEvent,
  AMPLITUDE_EVENTS,
  AMPLITUDE_PRODUCT_AREA,
} from "../utils/amplitude";

const goToDashboardText = "Go to your Postscript Dashboard";

const accountTitle = "Postscript Account";

const accountBody =
  "Log in to Postscript to view recent SMS performance and craft new conversations.";

const Account = () => {
  const appContext = useContext(AppContext);
  const appBridge = useAppBridge();
  const myShopifyDomain = appBridge.config.shop;

  if (!myShopifyDomain) {
    // Log but don't throw an error, we fallback to checking the URL params
    captureException(new Error("Shop domain not found in app bridge config"));
  }

  const handleRedirect = async () => {
    authenticateAndLogin(myShopifyDomain);
    emitAmplitudeEvent(
      AMPLITUDE_EVENTS.BUTTON_CLICKED,
      appContext.userId,
      appContext.shopId,
      {
        product_area: AMPLITUDE_PRODUCT_AREA,
        text: goToDashboardText,
      }
    );
  };

  return (
    <Layout.Section>
      <Card>
        <VerticalStack gap="0">
          <Text as="h2" variant="headingMd">
            {accountTitle}
          </Text>
          <p style={{ margin: "2rem 2rem 3rem .75rem" }}>{accountBody}</p>
          <HorizontalStack align="end">
            <Button primary onClick={() => handleRedirect()}>
              {goToDashboardText}
            </Button>
          </HorizontalStack>
        </VerticalStack>
      </Card>
      <hr
        style={{
          marginTop: "2rem",
          marginBottom: "2rem",
          borderTop: "1px solid #DDD",
        }}
      />
    </Layout.Section>
  );
};

export default Account;
